import { z } from 'zod';

export const CreatePurchaseReturnFormItemSchema = z.object({
    purchase_item_id: z.string(),
    purchase_item_name: z.string(),
    product_variation_id: z.string(),
    quantity: z.coerce.number().int().min(1),
    return_quantity: z.coerce.number().int().min(0),
    price: z.coerce.number().min(0),
    is_selected: z.boolean(),
});

export type TCreatePurchaseReturnFormItem = z.infer<
    typeof CreatePurchaseReturnFormItemSchema
>;

export const CreatePurchaseReturnFormSchema = z
    .object({
        items: z.array(CreatePurchaseReturnFormItemSchema).min(1),
        reason: z.string().trim().min(1, 'Reason is required'),
    })
    .superRefine((form, context) => {
        const selectedItems = form.items.filter((item) => item.is_selected);

        if (selectedItems.length === 0) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Select at least one item to return.',
                path: ['items'],
            });
        }

        form.items.forEach((item, index) => {
            if (
                item.is_selected &&
                (item.return_quantity < 1 ||
                    item.return_quantity > item.quantity)
            ) {
                context.addIssue({
                    code: z.ZodIssueCode.custom,
                    message:
                        'Return quantity must be between 1 and the purchased quantity.',
                    path: ['items', index, 'return_quantity'],
                });
            }
        });
    });

export type TCreatePurchaseReturnForm = z.infer<
    typeof CreatePurchaseReturnFormSchema
>;
